<template>
  <v-col cols="12" class="text-center my-6">
    <h1 class="text-h5 align-center mb-6 secondary--text">
      <v-icon left color="accent" class="mb-1">mdi-magnify</v-icon>
      Search results for 
      "<span v-html="query" class="primary--text"></span>"
    </h1>
    <v-divider></v-divider>
  </v-col>
</template>

<script>
  export default {
    name: 'SearchHeader',

    props: {
      query: {
        type: String,
        default: 'Tag'
      }
    }
  }
</script>
